import { useMutation } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

interface StartOAuthFlowParams {
  serverId: string;
}

export function useStartOAuthFlow(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();

  return useMutation({
    mutationFn: ({ serverId }: StartOAuthFlowParams) =>
      mcpRegistryService.startOAuthFlow(serverId, orgId!),
  });
}
